import { GridLayout, MainGrid, NavigateOpenRecordGridButton } from '@powerportalspro/react-fluent';

// The MainGrid's map layout: contacts listed as cards beside a map of where they are, at
// address1_latitude and address1_longitude. Clicking a card, or selecting several, brings them into
// view; a pin clicked selects its contact. The Open button is what makes the cards selectable. The
// layout needs <MapsProvider> from @powerportalspro/react-maps around the app.
// Dataverse's Active Contacts view: its id is the same in every environment.
const ACTIVE_CONTACTS_VIEW_ID = '00000000-0000-0000-00aa-000010001004';

export function MainGridMapSample() {
  return (
    <MainGrid
      tableName="contact"
      defaultViewId={ACTIVE_CONTACTS_VIEW_ID}
      defaultLayout={GridLayout.Map}
      allowChangingLayout
      cardImageColumn="entityimage"
      mapHeight="520px"
      pageSize={10}
    >
      <NavigateOpenRecordGridButton />
    </MainGrid>
  );
}
